<template>
  <v-main>
    <v-container
      fluid
      class="pa-0"
      >
      <div class="white px-8 py-5 d-flex flex-row justify-space-between align-center">
        <div
          class="d-flex fill-width align-center"
          >
          <go-back 
            class="shrink pr-3"
            ></go-back>
          <h2 class="my-2">Expensas</h2>

          <v-spacer></v-spacer>

          <create
            @reload="fetchBuildings"
            ></create>
        </div>
      </div>

      <div
        style="max-width: 800px"
        class="pa-3 mx-auto"
        >
        <div
          v-if="buildings.length"
          >
          <template
            v-for="building in buildings"
            >
            <building
              :building="building"
              :key="building.id"
              @reload="fetchBuildings"
              ></building>
          </template>
        </div>

        <v-alert
          v-else
          color="primary lighten-5"
          rounded="xl"
          >
          ¡Parece que aún no tienes complejos cargados! Crea uno nuevo para comenzar a operar.
        </v-alert>
      </div>
    </v-container>
  </v-main>
</template>

<script>
import { Buildings } from '@/graphql/queries/buildings'
import Building from '@/components/buildings/Building'
import Create from '@/components/buildings/Create'
import GoBack from '@/components/GoBack'

export default {
  data: () => ({
    buildings: []
  }),

  created () {
    this.fetchBuildings ()
  },

  methods: {
    fetchBuildings () {
      this.$apollo.query({
        query: Buildings,
        fetchPolicy: 'no-cache'
      }).then ( res => {
        this.buildings = res.data.buildings
      })
    }
  },

  components: {
    Building,
    GoBack,
    Create
  }
}
</script>
